module.exports = __webpack_public_path__ + "img/text_apply.f26cf9e9.png";